import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { initTelegramApp } from './lib/telegram.js';
import { installDevMock } from './lib/telegram-dev-mock.js';
import { initI18n, resolveInitialLocale } from './i18n/index.js';
import './index.css';

const queryClient = new QueryClient();

void (async () => {
  await installDevMock(); // no-op in prod (DCE'd by Vite)
  initTelegramApp();
  // Boot i18n with the best initial guess from Telegram; the App syncs to
  // User.language once /me/profile resolves.
  const tg = (globalThis as {
    Telegram?: { WebApp?: { initDataUnsafe?: { user?: { language_code?: string } } } };
  }).Telegram;
  const tgLang = tg?.WebApp?.initDataUnsafe?.user?.language_code ?? null;
  initI18n(resolveInitialLocale({ telegramLanguageCode: tgLang }));
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
})();
